import { combineReducers } from '@reduxjs/toolkit';
import auth from './slices/authSlice';
import ui from './slices/uiSlice';
import dashboard from './slices/dashboardSlice';
import users from './slices/usersSlice';
import news from './slices/newsSlice';
import quiz from './slices/quizSlice';
import payments from './slices/paymentsSlice';
import coupons from './slices/couponsSlice';
import categories from './slices/categoriesSlice';
import exams from './slices/examsSlice';
import alerts from './slices/alertsSlice';
import mains from './slices/mainsSlice';
import mainsQuestions from './slices/mainsQuestionsSlice';
import ai from './slices/aiSlice';
import downloads from './slices/downloadsSlice';
import banners from './slices/bannersSlice';
import scraper from './slices/scraperSlice';

export default combineReducers({
  auth,
  ui,
  dashboard,
  users,
  news,
  quiz,
  payments,
  coupons,
  categories,
  exams,
  alerts,
  mains,
  mainsQuestions,
  ai,
  downloads,
  banners,
  scraper,
});
